import { FormEvent, useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { DataTableFootnote } from "../../../../Models";

interface EditFootnoteModalProps {
    footnote: DataTableFootnote;
    onClose: () => void;
    onSubmit: (value: string) => void;
}

const EditFootnoteModal = ({ footnote: value, onClose, onSubmit }: EditFootnoteModalProps) => {
    const [footnote, setFootnote] = useState<string>(value.value);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    const onFormSubmit = (event: FormEvent) => {
        event.preventDefault();
        onSubmit(footnote);
    };

    return (
        <Dialog open={Boolean(value)} onClose={() => onClose()} fullWidth maxWidth={"sm"} fullScreen={fullScreen}>
            <form onSubmit={(event) => onFormSubmit(event)}>
                <DialogTitle>Edit footnote</DialogTitle>
                <DialogContent dividers>
                    <TextField
                        name="Footnote"
                        value={footnote}
                        onChange={(e) => setFootnote(e.currentTarget.value)}
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => onClose()}>Cancel</Button>
                    <Button variant="contained" type="submit">
                        Update
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default EditFootnoteModal;
